(async () => {
  const url = new URL(window.location.href);
  const referralCode = url.searchParams.get("affiliate");

  const updateReferralCodeInCartNotes = (notes, newCode) => {
    const pattern = /\[SALESTREAM_CODE\].+?\[SALESTREAM_CODE\]/;

    const newReferralString = `[SALESTREAM_CODE]${newCode}[SALESTREAM_CODE]`;

    if (pattern.test(notes)) {
      return notes.replace(pattern, newReferralString);
    }

    return notes + newReferralString;
  };

  if (referralCode) {
    const cartResponse = await fetch((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root||'/')+"cart.js");
    const cart = await cartResponse.json();
    const cartNote = cart.note || "";
    const newCartNote = updateReferralCodeInCartNotes(cartNote, referralCode);

    const resp = await fetch((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root||'/')+"cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ note: newCartNote }),
    });
    const res = await resp.json();
  }
})();
